import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GiftcardService } from '@src/app/ecom-gift-card/ecom-giftcard.service';
import { Discount } from '@src/app/ecom-models/discount';
import { User } from '@src/app/ecom-models/user';
import { EcomCartService } from '@src/app/ecom-services/ecom-cart.service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { QRType } from '@src/app/enums/qr-types.enum';
import { ToastService } from '@src/app/toast/toast.service';
import moment from 'moment';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { generateGuid, ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EcomOlarDataService } from 'src/app/ecom-data-services/ecom-olar-data-service';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { CategoryClass } from '../ecom-item-category/ecom-item-category.model';


@Component({
  selector: 'new-app-ecom-item-category-v2',
  templateUrl: './new-ecom-item-category-v2.component.html',
  styleUrls: ['./new-ecom-item-category-v2.component.scss'],
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('100ms', style({ opacity: 0 }))
      ])
    ]),
    trigger('inOutAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: '0' }), animate('.5s ease-out', style({ opacity: '1' }))]),
      transition(':leave', [style({ opacity: '1' }), animate('.5s ease-out', style({ opacity: '0' }))]),
    ]),
  ],
})
export class NewEcomItemCategoryV2Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('sentinel') sentinels!: QueryList<ElementRef>;
  @ViewChildren('sectionEl') sectionEls!: QueryList<ElementRef>;
  @ViewChild('scrollRoot', { static: true }) scrollRoot!: ElementRef;
  private observers: IntersectionObserver[] = [];
  isToday = true;
  categoryList: CategoryClass[] = [];
  //itemList = [];


  locationSelected: any;
  locationName = '';
  serviceType = '';
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  storeServiceBase: StoreServiceBase;

  settings: any;
  itemClicked: any;
  modalTooFar: BsModalRef;
  modalRef: BsModalRef;
  modalRefOlarmePromotion: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  configTooFar = {
    animated: true,
    class: 'modal-dialog-centered'
  };
  configscanner = {
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true,
    keyboard: false
  };

  width = 126;
  lastIndex: any;
  @ViewChild(BsDatepickerDirective, { static: false }) datepicker: BsDatepickerDirective;
  @ViewChild('itemScanner', { static: true }) itemScanner: ElementRef;

  qrCodeScanned = false;

  callGetCategoryItems = true;

  weburlOrder = false;
  displaymenutop = true;
  locationDefaultImage = './assets/images/homedefault.jpeg';
  defaultItemImage = './assets/images/Itemdefault.jpeg';
  defaultImage = './assets/images/Itemdefault.jpeg';
  companyName = '';

  locationDetails: any = '';

  dateList = [];

  deliverydistance = 0;

  serviceErrorMessage: any;  
 
  distanceError = false;
  IsTableQRCode = false;
  IsLocationQRCode = false;
  IsWebUrl = false;


  webCompanyId: any;
 
  categoryListResponse = [];

  warningMessage = '';
  weburlAddress = '';
  recommendedItems = [];

  environment: any;
  // order status popup

  configorderstatus = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  customer_order: any;
  showALTLanguage: boolean = false;

  isHorizontalMenu = false;
  selectedMenuId: number = 0;
  itemList: any;
  subMenus: any[] = [];
  newCategoryList: CategoryClass[] = [];
  showSubmenu: boolean;
  showSideBar: boolean;
  selectedSubMenuId: number = 0;
  showMenuId: number = 0;
  searchForm: FormGroup;
  showRecommended: boolean = false;
  tableName: string = "";

  queryCategoryId: number;

  bsModalRef: BsModalRef;
  showDetails: boolean = false;
  shoppingCart: any;
  toastMessage: string = '';
  showToast: boolean = false;
  drawerVisible = false;
  onClose: any;
  item_pkid: number;
  iscvsd_pkid: number;
  category_pkid: number;
  showOurMenu = true;

  banners: string[] = [];
  promotions: string[] = [];
  showBanner: boolean = false;
  selectedTime = '';
  selectedDate = '';
  backdrop: boolean = false;
  qrCodeType: number = 1;
  userInfo: User;
  // constructor to inject the class objects
  newCategoryItems: any[] = [];

  addonSelectedSubMenuId: any;

  allCategoryList: any[] = [];
  showGiftCard: boolean;

  showOrderTypePopup: boolean = false;
  companyLogo = "";

  constructor(public ecomOlarDataService: EcomOlarDataService, public router: Router, public ecomservice: EComService, private webstorage: EComWebStorage, private cookie: EcomCookies, public formBuilder: FormBuilder,
    private modalService: BsModalService, public location: Location,
    public activatedRoute: ActivatedRoute, { nativeElement }: ElementRef<HTMLImageElement>,
    private cartService: EcomCartService,
    private toastService: ToastService,
    private settingService: EcomSettingService,
    public giftcardService: GiftcardService,
    private cdr: ChangeDetectorRef) {
    this.userServiceBase = new UserServiceBase();
    this.userSelectedStore = new StoreServiceBase({});
    this.shoppingCart = this.webstorage.localSt_shopping_cart;
    const supports = 'loading' in HTMLImageElement.prototype;
    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
    this.environment = olarconfig.Environment;
    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });

    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });

    this.ecomOlarDataService.currentMenu.subscribe(menulist => {
      this.categoryListResponse = menulist;
    });
    this.ecomOlarDataService.currentMenunew.subscribe(menulist => {
      this.categoriesResponse = menulist;
    });

    this.settingService.currentCompanySetting.subscribe(setting => {
      if (!setting) return;

      this.serviceType = setting.serviceType;
      this.tableName = setting.tableName;
    });

    this.settingService.currentLocationSetting.subscribe(location => {
      if (!location) return;

      this.userSelectedStore = this.settingService.getSelectedStore(this.serviceType);
    });

    this.settingService.currentUserServiceBase.subscribe(userBase => {
      if (!userBase) return;

      this.selectedDate = userBase.selectedDate;
      this.selectedTime = userBase.selectedTime;
    });

    this.settingService.currentQRCodeType.subscribe(value => {
      this.IsTableQRCode = value === QRType.Table;
      this.showBanner = !this.IsTableQRCode;
      const self = this;
      this.qrCodeType = value;


    });

    this.settingService.currentUserInfo.subscribe(user => {
      this.userInfo = user;
    });


  }


  selectedLanguage: string;
  onLanguageSelected(language: string) {
    this.selectedLanguage = language;
    this.showALTLanguage = language === "zh";

  }

  openDetailDrawer(item) {
    this.drawerVisible = true;
    this.onClose = this.onDrawerVisibleChange.bind(this);
    this.item_pkid = item.item_pkid;
    this.iscvsd_pkid = item.ooip_iscvsd_pkid;
    this.category_pkid = !item.ooic_pkid ? null : item.ooic_pkid;
  }

  onDrawerVisibleChange($event) {
    this.drawerVisible = false;
    this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, this.categoryList);

    this.userServiceBase = this.settingService.getUserSerivce();
    const selectedStore = this.settingService.getSelectedStore(this.serviceType);

    if (selectedStore) {
      this.userSelectedStore = selectedStore;
    }
  }

  toggleSubMenu(event: MouseEvent, item, i) {
    //console.log("debbug");
    this.showMenuId = item.ooic_pkid;
    this.showSubmenu = !this.showSubmenu;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (!this.item_searched) {
      if (window.pageYOffset > 500) {
        let element = document.getElementById('navbar-item');
        if (element) {
          element.classList.add('location-sticky');
          element.classList.add('margin-top-0');
          element.classList.add('search-display-block');
          element.classList.remove('search-display-none');
        }
      } else {
        let element = document.getElementById('navbar-item');
        if (element) {
          element.classList.remove('location-sticky');
          element.classList.remove('margin-top-0');
          element.classList.remove('search-display-block');
          element.classList.add('search-display-none');
        }
      }
    }
  }

  @ViewChild('promotion', { static: true }) promotion: ElementRef;
  modalRefPromotions: BsModalRef;
  configPromotions = {
    animated: true,
    class: 'modal-dialog-centered modal-sm',
    ignoreBackdropClick: true,
    keyboard: false
  };


  @ViewChild('serviceTypeModal', { static: true }) serviceTypeModal: ElementRef;

  @ViewChild('paxModal', { static: true }) paxModal: ElementRef;

  modalRefPaxModal: BsModalRef;
  modalRefServiceTypeModal: BsModalRef;
  configserviceTypeModal = {
    animated: true,
    class: 'modal-dialog-centered modal-sm',
    ignoreBackdropClick: true,
    keyboard: false
  };

  showBuyGiftCard = false;

  // Method to handle the close icon click event
  onClosePromotionClick() {
    this.modalRefPromotions.hide();
  }

  onAndroidClick() {
    window.open('https://play.google.com/store/apps/details?id=com.merchantmate.mmolarme', "_blank");
  }

  onIOSClick() {
    window.open('https://apps.apple.com/app/olarme/id1606881014', "_blank");
  }



  addPax(pax: number) {
    const userInfo = this.settingService.getUserInfo();
    userInfo.pax = pax;
    this.settingService.setUserInfo(userInfo);

    this.modalRefPaxModal.hide();
  }

  // component initialize and load the required data
  async ngOnInit() {
    const userInfo = this.settingService.getUserInfo();
    if (this.serviceType === "DINE_IN" && userInfo.pax === 0) {
      this.modalRefPaxModal = this.modalService.show(this.paxModal, { ...this.configorderstatus, class: 'modal-dialog-centered modal-pax' });
    }

    if (!this.settingService.getCompanySetting()) {
      this.router.navigate(['home']);
      return;
    }
  

    this.categoryList = [];

    this.activatedRoute.paramMap.subscribe(params => {
      let merchatname: any = params.get('companyname');
      this.webstorage.sessionSt_company_clicked = merchatname.trim().replace(/\s+/g, '-').toLowerCase();
    });

    await this.QRCodeGetCompanySettings();

    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchTextValue => {
      this.searchItem(searchTextValue);
    });
  }

  async fetchGiftcard() {
    const setting = this.settingService.getCompanySetting();

    if (setting && setting.oocls_company_id) {
      const companyId = setting.oocls_company_id;
      const res = await this.giftcardService
        .fetchGiftcards({ companyId: companyId })
        .toPromise();

      if (res.isSuccess && res.listValue && res.listValue.giftcards && res.listValue.giftcards.length > 0) {
        this.showBuyGiftCard = true;
      }

    }
  }

  ngAfterViewInit() {
    this.sentinels.changes.subscribe(() => {
      //console.log('[VIEW] sentinels changed');
      this.setupObservers();
    });

    setTimeout(() => this.setupObservers(), 0);
  }


  ngOnDestroy() {
    this.disconnectObservers();
  }

  private disconnectObservers() {
    for (let i = 0; i < this.observers.length; i++) {
      this.observers[i].disconnect();
    }
    this.observers = [];
  }


  private setupObservers() {
    this.disconnectObservers();

    let sentinelArr = [];
    if (this.sentinels && this.sentinels.toArray) {
      sentinelArr = this.sentinels.toArray();
    }

    if (!sentinelArr.length) {
      //console.log('[VIEW] no sentinel -> skip');
      return;
    }

    sentinelArr.forEach((elRef, idx) => {
      const menu = this.newCategoryList[idx];
      if (!menu) {
        return;
      }

      const io = new IntersectionObserver((entries) => {
        for (let i = 0; i < entries.length; i++) {
          const e = entries[i];
          if (!e.isIntersecting) continue;

          // console.log(
          //   '[IO] in viewport -> menuId=' + menu.ooic_pkid +
          //   ' name=' + menu.ooic_name +
          //   ' loaded=' + menu.loaded +
          //   ' loading=' + menu.loading
          // );

          this.loadMenuFirstTime(menu);
        }
      }, {
        root: this.scrollRoot.nativeElement,
        threshold: 0,
        rootMargin: '0px'
      });

      io.observe(elRef.nativeElement);
      this.observers.push(io);
    });

    //console.log('[VIEW] observers bound = ' + this.observers.length);
  }

  scrollToNew(index: number) {
    const arr = this.sectionEls.toArray();
    if (!arr[index]) return;

    console.log(`[MENU CLICK] scrollTo -> ${this.newCategoryList[index].ooic_name}`);

    arr[index].nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  getActiveSubItems(category: any) {
    if (!category || !category.subMenus || !category.subMenus.length) return [];

    var activeId = category.activeSubMenuId;
    for (var i = 0; i < category.subMenus.length; i++) {
      var sm = category.subMenus[i];
      if (sm.id === activeId) {
        return sm.items || [];
      }
    }
    return [];
  }
  onSubMenuClickNew(cat, sub: CategoryClass, index) {
    cat.activeSubMenuId = sub.ooic_pkid;
    cat.activeSubMenu = sub;
  }

  onAddonSubMenuClickNew(cat, sub: CategoryClass, index) {
    cat.activeAddonSubMenuId = sub.ooic_pkid;
    cat.activeAddonSubMenu = sub;
  }

  private async loadMenuFirstTime(menu) {
    const companyId = this.locationSelected.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;

    if (menu.loaded || menu.loading) return;

    // Recommended items already loaded => skip
    if (menu.ooic_pkid === 0) {
      menu.loaded = true;
      return;
    }


    let isCatagoryAvailable = true;
    if (menu.timeList.length) {
      const slot = menu.timeList[0];
      isCatagoryAvailable = this.isNowInTimeRange(slot.StartTime, slot.EndTime);
    }

    const byName = (a: any, b: any) =>
      a.item_name.localeCompare(b.item_name, undefined, { numeric: true });

    menu.loading = true;
    console.log(`[API] CALL items for menuId=${menu.ooic_name}`);

    const res = await this.getItemsByCategory(companyId, locationPkid, menu.ooic_pkid);
    // check res null/undefined
    const list = (res && res.length) ? res : [];
    let items = [];

    if (list.length) {

      list.forEach(element => {

        let categoryActive = true;

        if (menu.ooic_pkid === element.ooic_pkid) {
          categoryActive = isCatagoryAvailable;
        } else {
          const findMenu = this.newCategoryList.find(x => x.ooic_pkid === element.ooic_pkid);
          if (findMenu && findMenu.timeList.length) {
            const slot = findMenu.timeList[0];
            categoryActive = this.isNowInTimeRange(slot.StartTime, slot.EndTime);
          }
        }

        if (!element.ItemPricingDineIn) return;

        element.ItemPricingDineIn.forEach(elementitem => {


          let itemprice = elementitem.ooip_price_value;
          let discountedPrice = 0;

          const categoryItemAvailable = categoryActive && elementitem.ooip_is_active;
          //console.log("debbug");
          const item = this.mapItemData(elementitem, elementitem.item_description, categoryItemAvailable, itemprice, discountedPrice, element.ooic_parent_pkid, element.ooic_pkid)
          items.push(item);
        });

      });

      //console.log("new", items);
    }

    //
    if (!menu.subMenus.length) {
      menu.items = items.filter(x => x.ooic_pkid === menu.ooic_pkid).sort(byName);
    }
    else {
      menu.subMenus.forEach(sub => {
        const subItems = items.filter(x => x.ooic_pkid === sub.ooic_pkid);
        sub.items = subItems.sort(byName);
      });

      menu.activeSubMenu = menu.subMenus[0];
    }

    // 3) Addon
    if (menu.addon_pkid) {

      const addonMenu = this.allCategoryList.find((x: any) => x.ooic_pkid === menu.addon_pkid);

      if (addonMenu) {
        menu.addon_items = items.filter(x => x.ooic_pkid === addonMenu.ooic_pkid);

        // If has subMenus, first sub menu is priority
        const addOnSubMenus = this.allCategoryList.filter((x: any) => x.ooic_parent_pkid === addonMenu.ooic_pkid);

        if (addOnSubMenus.length) {
          menu.addonSubMenus = addOnSubMenus;
          menu.addon_items = [];

          addOnSubMenus.forEach(sub => {
            const subItems = items.filter(x => x.ooic_pkid === sub.ooic_pkid);
            sub.items = subItems.sort(byName);
          });

          menu.activeAddonSubMenuId = addOnSubMenus[0].ooic_pkid;
          menu.activeAddonSubMenu = addOnSubMenus[0];
        }
      }
    }


    //console.log(111, items)

    menu.loaded = true;
    menu.loading = false;

    //console.log('[API] DONE menuId=' + menu.ooic_name + ' items=' + menu.items.length);


  }
  async fetchCustomerLoyalty() {
    const user = this.settingService.getUserInfo();
    if (!user.userPkid) return;

    const setting = this.settingService.getCompanySetting();

    const model = {
      type: this.serviceType,
      companyId: setting.oocls_company_id,
      locationPkid: setting.oocls_location_pkid,
      customer_pkid: user.userPkid
    }

    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_OLAR_CUSTOMER_LOYALTY}`, model, '', true)
      .toPromise();
    //console.log(response);
    if (response.isSuccess && response.listValue) {
      //this.customerLoyalty = response.listValue;
      const data = response.listValue;
      this.settingService.setUserInfo(new User({
        ...user,
        originPoints: data.points,
        points: data.points,
        loyalty_tier: data.loyalty_tier,
        amount: data.points && data.ratio ? Number(data.points / data.ratio) : 0,
        maximum_redemtion: data.maximum_redemtion,
        amountUnit: data.amountUnit,
        pointsPerUnit: data.pointsPerUnit,
        earnPointTaxMode: data.earnPointTaxMode,
        minOrderAmountForPoints: data.minOrderAmountForPoints,
        maxUses: data.maxUses,
        ratio: data.ratio,
        programCurrency: data.programCurrency,
        month: data.month,
        next_tier: data.next_tier,
        spend_more: data.spend_more
      }));
    }

  }

  async getDiscounts(locationPkid: number) {
    if (this.settingService.getDiscounts().length) return;

    const companyId = this.locationSelected.company_id;
    const response = await this.ecomservice.httpGet(`${EcomNetworkUtils.GET_DISCOUNTS_BY_LOCATION_ID}?companyId=${companyId}&locationId=${locationPkid}`, '', false)
      .toPromise();
    if (response.status === 200) {
      const discounts = response.listValues.map(x => new Discount(x));
      this.settingService.setDiscounts(discounts);
    }

  }
  async QRCodeGetCompanySettings() {

    const setting = this.settingService.getCompanySetting();
    const model = {
      oocls_location_pkid: setting.oocls_location_pkid,
      oocls_company_id: setting.oocls_company_id,
      companyPkid: setting.oocls_company_pkid
    }

    await this.fetchCustomerLoyalty();
    await this.fetchGiftcard();
    const response = await this.fetchLocationSetting(model);

    if (response) {
      const data = response;
      if (!data) return;

      this.settingService.setLocationSetting(data);
      this.settings = data;
      this.webstorage.sessionSt_settings = this.settings;
      this.QRCodeAddServiceRequestBase();

      this.banners = data.banners;
      if (!this.serviceType) this.selectService();

      this.locationSelected = this.settingService.getLocationSetting();
      await await this.getCategoryItems();
    }

  }

  async fetchLocationSetting(model) {
    // const data = this.settingService.getLocationSetting();
    // if (data) return data;
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_LOCATIONS_SETTINGS, model, '', true).toPromise();
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
    } else {
      if (response.isSuccess) {
        this.ecomservice.loadingPage.loading = false;
        this.settingService.setLocationSetting(response.listValue);
        return response.listValue;

      }
    }
  }

  getCurrentDateTime2() {
    return moment().format('YYYY-MM-DD hh:mm A');
  }

  QRCodeAddServiceRequestBase() {

    const setting = this.settingService.getCompanySetting();
    const locationSelected = this.settingService.getLocationSetting();
    this.userServiceBase = this.settingService.getUserSerivce();
    //his.userServiceBase.userCurrentLocationIn = setting.oocls_location_pkid;
    this.storeServiceBase = new StoreServiceBase({
      serviceLocationAddress: locationSelected.mm_online_order_location_settings.ools_location_addres,
      serviceLocationName: locationSelected.mm_online_order_location_settings.store_name,
      serviceType: this.serviceType,
      serviceStatus: 'OPEN',
      locationPkid: locationSelected.mm_online_order_location_settings.ools_location_pkid,
      serviceLocationTableId: setting.tablePkid + "",
      serviceLocationTableName: setting.tableName,
      serviceQRScanned: this.qrCodeScanned,
      serviceCompanyId: locationSelected.company_id
    });

    this.storeServiceBase.serviceDatetime = this.getCurrentDateTime2();

    if (!this.userServiceBase.selectedStoreServiceList || !this.userServiceBase.selectedStoreServiceList.length) {
      this.userServiceBase.selectedStoreServiceList = [];
      this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
      this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
    } else {
      // check if same location same service selected again then update details
      let storeIndex = -1;
      const storeselected = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        storeIndex = index;
        return obj.locationPkid === locationSelected.mm_online_order_location_settings.ools_location_pkid && obj.serviceType == this.serviceType;
      });
      if (!storeselected) {
        this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
        this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
        this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      } else {

        this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length;

        //const datetime = this.storeForm.controls.date.value + ' ' + this.storeForm.controls.timeselected.value;
        this.userServiceBase.selectedStoreServiceList[storeIndex].serviceDatetime = this.getCurrentDateTime2();

      }
    }
    //this.webstorage.localSt_user_service_request = this.userServiceBase;
    this.settingService.setUserSerivce(this.userServiceBase)
  }


  // Method to get the dateformat
  getDateFormat(today: Date) {
    let day = today.getDate() + '';
    let month = (today.getMonth() + 1) + '';
    let year = today.getFullYear() + '';
    let hour = today.getHours() + '';
    let minutes = today.getMinutes() + '';
    let seconds = today.getSeconds() + '';

    day = this.checkZero(day);
    month = this.checkZero(month);
    year = this.checkZero(year);
    hour = this.checkZero(hour);
    minutes = this.checkZero(minutes);
    seconds = this.checkZero(seconds);
    //return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
    return year + '-' + month + '-' + day;
  }

  // Method to append the zero
  checkZero(data) {
    if (data.length === 1) {
      data = '0' + data;
    }
    return data;
  }

  // Method to load form control



  isNowInTimeRange(startTime, endTime) {
    const now = new Date();
    const nowSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    const startSeconds = this.getSeconds(startTime);
    const endSeconds = this.getSeconds(endTime);

    if (startSeconds <= endSeconds) {
      // Ví dụ: 14:00 → 23:30
      return nowSeconds >= startSeconds && nowSeconds <= endSeconds;
    } else {
      // Trường hợp qua nửa đêm: ví dụ 23:00 → 02:00
      return nowSeconds >= startSeconds || nowSeconds <= endSeconds;
    }
  }

  getSeconds(timeStr) {
    const [h, m, s] = timeStr.split(':').map(Number);
    return h * 3600 + m * 60 + s;
  }

  async onMenuClick(category: CategoryClass, index: number, scroll = false) {

    this.showOurMenu = false;
    this.showBanner = false;
    this.item_searched = false;
    this.searchValue = "";

    this.showRecommended = false;
    this.closeDrawer();
    this.selectedSubMenuId = 0;
    this.subMenus = [];
    this.isHorizontalMenu = true;
    this.selectedMenuId = category.ooic_pkid;

    setTimeout(() => {
      this.scrollToNew(index);
    }, 500);
  }
  //  Right menu
  updateShellRight = () => {
    const rect = this.shell.nativeElement.getBoundingClientRect();
    const rightGap = Math.max(0, window.innerWidth - rect.right);
    document.documentElement.style.setProperty('--shell-right', `${rightGap}px`);
    document.documentElement.style.setProperty('--shell-width', `${rect.width}px`);
  };
  drawerOpen = false;

  @ViewChild('shell', { static: true }) shell!: ElementRef<HTMLElement>;
  @ViewChild('drawer', { static: true }) drawer!: ElementRef<HTMLElement>;
  @ViewChild('overlay', { static: true }) overlay!: ElementRef<HTMLElement>;
  private scrollResetTmr: any;

  openDrawer() {
    this.updateShellRight();
    this.drawerOpen = true;
    document.body.classList.add('mm-lock');

    // delay 1s then scrollTo top
    clearTimeout(this.scrollResetTmr);
    this.scrollResetTmr = setTimeout(() => {
      if (this.drawer && this.drawer.nativeElement) {
        const scroller = this.drawer.nativeElement.querySelector('.mm-content') as HTMLElement;
        if (scroller) {
          if (scroller.scrollTo) scroller.scrollTo(0, 0);
          else scroller.scrollTop = 0;
        }
      }
    }, 1000);
  }

  closeDrawer() {
    this.drawerOpen = false;
    document.body.classList.remove('mm-lock');
    clearTimeout(this.scrollResetTmr);
  }

  openHistory() {
    this.closeDrawer();
    this.router.navigate(['status-dinein']);
  }
  //  end right menu

  mainPage() {
    this.closeDrawer();
    this.showOurMenu = true;
    this.showBanner = true;
    this.showRecommended = true;
    this.isHorizontalMenu = false;
    this.itemList = [];
    this.subMenus = [];
  }

  onRightSideSubMenuClick(subCategory, scroll = false) {
    this.selectedSubMenuId = 0;
    const subCategoryItem = this.categoryList.find(x => x.ooic_pkid === subCategory.ooic_pkid);
    if (subCategoryItem) {
      this.itemList = subCategoryItem.items;
      this.selectedSubMenuId = subCategoryItem.ooic_pkid;
      this.selectedMenuId = subCategoryItem.ooic_parent_pkid;
      const subMenus = this.categoriesResponse.filter(x => x.ooic_parent_pkid === subCategory.ooic_parent_pkid);
      if (subMenus.length) {
        const parentPkids = subMenus.map(x => x.ooic_pkid)
        this.subMenus = this.categoryList.filter(x => parentPkids.includes(x.ooic_pkid));

        this.itemList = subCategoryItem.items;
        this.isHorizontalMenu = true;
      }
      this.closeDrawer();
      if (scroll) {
        this.scrollToItem();
      }

    }


  }
  scrollToItem() {
    setTimeout(() => {
      document.getElementById('itemList').scrollIntoView({ behavior: 'smooth' });
    }, 300);
  }


  async getCategories(companyId, locationId, orderDatetime, companyPkid: number) {
    const input = {
      company_id: companyId,
      location_pkid: locationId,
      datetime: orderDatetime,
      companyPkid: companyPkid
    };
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_CATEGORIES, input, '', true).toPromise();
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
    } else {
      if (response.isSuccess) {
        //this.categoriesResponse = response.listValues;
        this.newCategoryList = [];

        const all = response.listValues || [];

        this.allCategoryList = all;
        // parents
        const parents = all
          .filter(x => !x.ooic_parent_pkid)
          .sort((a, b) => (a.order_sequence || 0) - (b.order_sequence || 0))
          .map(x => this.createMenu(x));

        // map submenu
        const parentMap: any = {};
        for (let i = 0; i < parents.length; i++) {
          parentMap[parents[i].ooic_pkid] = parents[i];
        }

        const subs = all
          .filter(x => x.ooic_parent_pkid)
          .sort((a, b) => (a.order_sequence || 0) - (b.order_sequence || 0))
          .map(x => this.createMenu(x));

        // attach
        for (let i = 0; i < subs.length; i++) {
          const sm = subs[i];
          const p = parentMap[sm.ooic_parent_pkid];
          if (!p) continue; //

          if (!p.subMenus) p.subMenus = [];
          p.subMenus.push(sm);
        }

        // default active submenu
        for (let i = 0; i < parents.length; i++) {
          const p = parents[i];
          if (p.subMenus && p.subMenus.length > 0) {
            p.activeSubMenuId = p.subMenus[0].ooic_pkid;
            p.items = [];
          }
        }

        this.newCategoryList = parents;

        // Fetch favorite Items
        const categoryIds = response.listValues.map(x => x.ooic_pkid);
        await this.getItems(companyId, locationId, categoryIds);

        this.cdr.detectChanges();


      }
    }

  }

  trackByMenu(_: number, m) {
    return m.ooic_pkid;
  }

  trackByItem(_: number, it: any) {
    return it.item_pkid;
  }

  createMenu(cat: any) {
    return {
      ooic_pkid: cat.ooic_pkid,
      ooic_parent_pkid: cat.ooic_parent_pkid,
      ooic_name: cat.ooic_pkid === 0 ? "Recommended" : cat.ooic_name,
      ooic_image: cat.ooic_pkid === 0 ? "assets/images/homeicons/Recommendation.png" : cat.ooic_image,
      ooic_alternative_name: cat.ooic_alternative_name,
      items: [],
      active: cat.availableForSelectedDateTime,
      timeList: cat.timeSlots,
      addon_pkid: cat.ooic_addon_pkid,
      order_sequence: cat.order_sequence,
      loaded: false,
      loading: false,
      subMenus: [] as any[],
      activeSubMenuId: null,
      activeSubMenu: null,
      showAddon: false,
      addon_items: [],
      addonSubMenus: [] as any[],
      activeAddonSubMenuId: null,
      activeAddonSubMenu: null
    };
  }

  showAddonClickNew(cat) {
    cat.showAddon = true;
  }

  // Method to get the category items
  async getCategoryItems() {
    await this.getDiscounts(this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
    if (this.userServiceBase) {
      let serviceActiveId = this.webstorage.sessionSt_service_active_id;
      if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        serviceActiveId = 1;
      }

      let userStoreIndex = -1;
      const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        userStoreIndex = index;
        //console.log(this.locationSelected.mm_online_order_location_settings.ools_location_pkid)
        return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid
          && !obj.serviceCompleted
          && obj.serviceType == this.serviceType;
      });
      this.userSelectedStore = selectedStore;
      const companyId = this.locationSelected.company_id;
      const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;


      if (this.callGetCategoryItems || this.categoryListResponse.length === 0) {
        //console.log("debbug");
        await this.getCategories(companyId, locationPkid, null, this.settings.oocls_company_pkid);

      } else {
        this.ecomservice.loadingPage.loading = false;

      }
    }
  }

  async getItems(companyId: string, locationPkid: number, categoryIds: number[]) {
    const model = {
      companyId: companyId,
      locationPkid: locationPkid,
      categoryIds: categoryIds,
      //serviceType: this.serviceType
    }

    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_CATEGORY_ITEMS, model, '', false)
      .toPromise();
    this.ecomservice.loadingPage.loading = false;
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return [];
    }

    if (response.status === 200) {
      // check res null/undefined
      const list = (response && response.listValues.length) ? response.listValues : [];
      let items = [];

      if (list.length) {

        list.forEach(element => {
          let categoryActive = element.availableForSelectedDateTime;
          if (!element.ItemPricingDineIn) return;

          element.ItemPricingDineIn.forEach(elementitem => {


            let itemprice = elementitem.ooip_price_value;
            let discountedPrice = 0;

            const categoryItemAvailable = categoryActive && elementitem.ooip_is_active && elementitem.availableForSelectedDateTime;
            //console.log("debbug");
            const item = this.mapItemData(elementitem, elementitem.item_description, elementitem.ooip_is_active, itemprice, discountedPrice, element.ooic_parent_pkid, element.ooic_pkid)
            items.push(item);
          });

          const recommended = this.newCategoryList.find(x => x.ooic_pkid === 0)

          if (recommended) {
            recommended.items = items;
            this.recommendedItems = items;
            this.showRecommended = items.length > 0;
          }

        });

        //console.log("new", items);
      }
    }


  }


  async getItemsByCategory(companyId: string, locationPkid: number, categoryId: number) {
    const model = {
      companyId,
      locationPkid,
      categoryId,
      //serviceType: this.serviceType
    }

    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_ITEMS_BY_CATEGORY, model, '', false)
      .toPromise();
    this.ecomservice.loadingPage.loading = false;
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return;
    }

    return response.listValues;
  }

  async getItemsByName(companyId: string, locationPkid: number, name: string) {
    const model = {
      companyId,
      locationPkid,
      name
    }

    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_ITEMS_BY_NAME, model, '', true)
      .toPromise();
    this.ecomservice.loadingPage.loading = false;
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return;
    }


    const list = (response && response.listValues && response.listValues.length) ? response.listValues : [];
    let items: any = [];

    if (list.length) {

      list.filter((element: any) => element.ItemPricingDineIn && element.ItemPricingDineIn.length).forEach((element: any) => {

        let categoryActive = true;
        const menu = this.newCategoryList.find(x => x.ooic_pkid === element.ooic_pkid);

        if (menu && menu.timeList.length) {
          const slot = menu.timeList[0];
          categoryActive = this.isNowInTimeRange(slot.StartTime, slot.EndTime);
        }

        element.ItemPricingDineIn.forEach(elementitem => {

          let itemprice = elementitem.ooip_price_value;
          let discountedPrice = 0;

          const categoryItemAvailable = categoryActive && elementitem.ooip_is_active;
          //console.log("debbug");
          const item = this.mapItemData(elementitem, elementitem.item_description, categoryItemAvailable, itemprice, discountedPrice, element.ooic_parent_pkid, element.ooic_pkid)
          items.push(item);
        });

      });

      this.searched_item_list = items;
    }
  }

  categoriesResponse = [];

  mapItemData(elementitem, itemDescription, categoryItemAvailable, itemprice, discountedPrice, ooic_parent_pkid, ooic_pkid) {
    let price = elementitem.ooip_dinein_discount_price_value ? elementitem.ooip_dinein_discount_price_value : elementitem.ooip_price_value;
    // if (this.serviceType === "COLLECTION") {
    //   price = elementitem.ooip_collection_discount_price_value ? elementitem.ooip_collection_discount_price_value : elementitem.ooip_price_value;
    // }

    if (this.serviceType === "DELIVERY") {
      price = elementitem.ooip_delivery_discount_price_value ? elementitem.ooip_delivery_discount_price_value : elementitem.ooip_price_value;
    }

    return {
      ooip_iscvsd_pkid: elementitem.ooip_iscvsd_pkid,
      imagepath: elementitem.item_image,
      imagecolor: elementitem.item_color,
      item_pkid: elementitem.item_pkid,
      item_name: elementitem.item_name,
      item_alternative_name: elementitem.item_alternative_name,
      variants: elementitem.variants,
      item_description: itemDescription,
      store_price_value: elementitem.store_price_value,
      ooip_allow_collection: elementitem.ooip_allow_collection,
      ooip_allow_delivery: elementitem.ooip_allow_delivery,
      ooip_max_per_day: elementitem.ooip_max_per_day,
      ooip_max_per_order: elementitem.ooip_max_per_order,
      ooip_price_value: elementitem.ooip_price_value,
      quantity: 0,
      outofstock: elementitem.outofstock,
      barcode: elementitem.BarCode,
      HasVariant: elementitem.HasVariant,
      categoryAvailable: true,
      itemPrice: price,
      discountedPrice: discountedPrice,
      ooic_parent_pkid: ooic_parent_pkid,
      ooic_pkid: ooic_pkid,
      discounts: elementitem.discounts,
      variantsLoaded: false,
      //itemAvailable: this.checkAvailable()
      itemAvailable: !categoryItemAvailable ? categoryItemAvailable : elementitem.available,
    };
  }


  checkAvailable() {
    const isAvailable = this.settingService.getQRCodeType();
    return true;
  }

  // Method to handle the item click event
  async onItemClick(item, type, category) {
    const setting = this.settingService.getLocationSetting();
    //console.log("onItemClick - table_qr_paymentmode", this.webstorage.sessionSt_settings.table_qr_paymentmode)
    // Variants already loaded
    if (item.variantsLoaded) return;

    if (item.HasVariant) {
      const companyId = this.locationSelected.company_id;
      const locationGuid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;

      const response = await this.ecomservice.httpGet(`${EcomNetworkUtils.GET_ITEM_VARIANTS}?companyId=${companyId}&itemPkid=${item.item_pkid}&locationId=${locationGuid}`, '', false)
        .toPromise()
      this.ecomservice.loadingPage.loading = false;
      item.variantsLoaded = true;
      if (response.status === 200) {
        const lst = response.listValues.map(elementitem => {


          let itemDescription = '';
          if (elementitem.item_description && elementitem.item_description.length > 0) {
            itemDescription = elementitem.item_description;
          }
          let itemprice = elementitem.ooip_price_value;
          let discountedPrice = 0;
          if (elementitem.ooip_dinein_discount_price_value && elementitem.ooip_dinein_discount_price_value > 0) {
            discountedPrice = Number(elementitem.ooip_dinein_discount_price_value);
          }

          //console.log("debbug");
          const object = this.mapItemData(elementitem, itemDescription, item.categoryAvailable, itemprice, discountedPrice, item.ooic_parent_pkid, item.ooic_pkid)
          //items.push(item);

          object['discounts'] = elementitem.discounts;
          return object
        });
        if (!this.item_searched) {

          if (!category) {
            this.recommendedItems.splice(this.recommendedItems.indexOf(item) + 1, 0, ...lst);
            return;
          }
          if (category && category.activeAddonSubMenu) {
            let arr = [...category.activeAddonSubMenu.items]; // copy
            const idx = arr.indexOf(item);
            arr.splice((idx >= 0 ? idx : -1) + 1, 0, ...lst);
            arr.sort((a, b) => a.item_name.localeCompare(b.item_name, undefined, { numeric: true }));
            category.activeAddonSubMenu.items = arr;
          } else {
            let arr = [...category.items];
            const idx = arr.indexOf(item);
            arr.splice((idx >= 0 ? idx : -1) + 1, 0, ...lst);
            arr.sort((a, b) => a.item_name.localeCompare(b.item_name, undefined, { numeric: true }));
            category.items = arr;
          }

        } else {
          this.searched_item_list.splice(this.searched_item_list.indexOf(item) + 1, 0, ...lst);
        }

      }

      return;
    }

    // M means view menu only
    if (this.qrCodeType === QRType.Table && setting.table_qr_paymentmode === "M") {
      this.toastService.show('The menu is available in view-only mode!');

      return;
    }

    if (this.qrCodeType === QRType.Store && setting.store_qr_paymentmode === "M") {
      this.toastService.show('The menu is available in view-only mode!');

      return;
    }

    this.webstorage.sessionSt_item_selected = item;

    this.openDetailDrawer(item);
  }

  updateMaxUsersPerOrder(item: ItemBase) {
    const localDiscounts = this.webstorage.sessionSt_discounts;
  }

  onViewCartClickHanlder() {
    this.onViewCartClickHanlder1();
  }


  onViewCartClickHanlder1() {
    let proceedToDetails = true;
    //if qrpayment mode is menu then user can view menu only
    if (this.webstorage.sessionSt_qr_paymentmode) {
      if (this.webstorage.sessionSt_qr_paymentmode === 'MENU') {
        proceedToDetails = false;
      } else {
        proceedToDetails = true;
      }
    }
    if (proceedToDetails) {
      this.ViewCart();
      // if (this.serviceType === 'DINE_IN') {
      //   this.ViewCart();
      // }
    }
  }

  checkMore() {
    // if (!this.userSelectedStore.storeCart.orderItems.length) {
    //   this.toastService.show("Please add at least 1 item to cart!");
    //   return;
    // }
    this.webstorage.sessionSt_autoOpenReward = true;

    this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
  }

  // Method to handle the view cart click event
  ViewCart() {
    // update the date and time of the selected service type
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.settingService.getSelectedStore(this.serviceType);


    selectedStore.serviceDatetime = selectedStore.serviceDatetime;

    this.userSelectedStore = selectedStore;
    // update back to local storage
    this.userServiceBase.selectedStoreServiceList[userStoreIndex] = selectedStore;
    //this.webstorage.localSt_user_service_request = this.userServiceBase;
    this.settingService.setUserSerivce(this.userServiceBase);

    // make sure any one of the service type is checked
    if (!this.serviceType) {
      let message = 'Please select any one of the service to continue';
      this.serviceErrorMessage = message;
      //this.modalRef = this.modalService.show(this.locationErrorMessage, this.config);
    } else {
      this.webstorage.sessionSt_cart_location_changed = undefined;
      this.webstorage.sessionSt_frompage = 'items';
      //this.gTagViewCart(selectedStore);
      this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
    }
  }
  // Method to handle the scan click event
  onScanClick() {
    let proceedToDetails = true;
    //if qrpayment mode is menu then user can view menu only
    if (this.webstorage.sessionSt_qr_paymentmode) {
      if (this.webstorage.sessionSt_qr_paymentmode === 'MENU') {
        proceedToDetails = false;
      } else {
        proceedToDetails = true;
      }
    }
    if (proceedToDetails) {
      this.webstorage.sessionSt_frompage = 'items';
      this.modalRef = this.modalService.show(this.itemScanner, this.configscanner);
    }
  }

  // Methos to handle scanner submit click event
  onScannerSubmit(event) {

  }


  scrollPage() {
    this.scrollToItem();
  }

  onServiceTypeClick(type) {
    this.mainPage();    
    this.distanceError = false;
    this.serviceErrorMessage = undefined;
    this.serviceType = type;
    const setting = this.settingService.getCompanySetting();
    if (setting) {
      setting.serviceType = type;
      this.companyLogo = setting.company_logo;
      this.settingService.setCompanySetting(setting);
    }
    switch (type) {
      case 'DINE_IN':
     
        break;
      case 'COLLECTION':
      
        break;
     
    }

    this.showOrderTypePopup = false;
   
    const userInfo = this.settingService.getUserInfo();
    if (this.serviceType === "DINE_IN" && userInfo.pax === 0) {
      this.modalRefPaxModal = this.modalService.show(this.paxModal, { ...this.configorderstatus, class: 'modal-dialog-centered modal-pax' });
    }

  }


  showScrollTop = false;

  onMenuScroll(el: HTMLElement) {
    this.showScrollTop = el.scrollTop > 200;
  }

  scrollMenuToTop() {
    this.scrollRoot.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    this.showScrollTop = false;
  }

  // Method to validate the pax
  onKeyPax(event) {
    const value = event.target.value;
    // validate with deposite rules

  }

  onCloseClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  searchValue: any;
  private subject: Subject<string> = new Subject();
  item_searched = false;
  searched_item_list: any[] = [];
  // Method to handle the key events
  onKey(searchtext: string) {
    this.closeDrawer();
    //key code
    this.searchValue = searchtext;
    if (!this.searchValue) {
      this.item_searched = false;
      return;
    }
    this.subject.next(this.searchValue);
  }

  async searchItem(searchtext: string) {
    this.item_searched = false;
    if (searchtext.length < 3) return;

    this.item_searched = true;
    const lowerCaseSearchText = searchtext.toLowerCase();
    const seenItems = new Set();

    this.searched_item_list = [];

    const allItems = this.flattenLoadedItems(this.newCategoryList);

    const textMatchedItems = allItems.filter(item =>
      item.item_name.toLowerCase().includes(lowerCaseSearchText)
    );

    textMatchedItems.forEach(item => {
      if (!seenItems.has(item.item_name)) {
        this.searched_item_list.push({ ...item, variantsLoaded: false });
        seenItems.add(item.item_name);
      }
    });

    // If no local data found, fetch from server
    if (this.searched_item_list.length === 0) {
      try {
        const companyId = this.locationSelected.company_id;
        const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;

        await this.getItemsByName(companyId, locationPkid, searchtext);
      } catch (error) {
        console.log('Error fetching items by name:', error);
      }
    }
  }

  flattenLoadedItems(menus: any[]) {
    const out: any[] = [];

    menus.forEach(m => {
      // no submenus
      if (!m.subMenus || m.subMenus.length === 0) {
        if (m.items.length) {
          m.items.forEach((it: any) => {
            out.push(it);
          });
        }
        return;
      }

      // has submenus
      m.subMenus.forEach((s: any) => {
        if (m.items.length) {
          s.items.forEach((it: any) => {
            out.push(it);
          });
        }
      });

      // addon
      m.addonSubMenus.forEach((s: any) => {
        if (m.items.length) {
          s.items.forEach((it: any) => {
            out.push(it);
          });
        }
      });

    });

    return out;
  }


  backToMainMenu() {
    this.item_searched = false;
    this.searchValue = '';
    var elmnt = document.getElementById('main_menu');
    if (elmnt) {
      elmnt.scrollIntoView({ behavior: 'smooth' });
    }
    let element = document.getElementById('navbar-item');
    if (element) {
      element.classList.add('location-sticky');
      element.classList.add('margin-top-0');
      element.classList.remove('search-display-block');
      element.classList.add('search-display-none');
    }
  }

  isExpanded = false;


  selectService() {
    //this.serviceTypeDrawerVisible = true;
    //if (this.userServiceBase.hasUnpaidOrder) return;
    if (this.settings.store_qr_takeaway && this.settings.store_qr_dinein)
      this.showOrderTypePopup = true;
  }

  onCloseServiceType() {
    this.modalRefServiceTypeModal.hide();
  }

  login() {
    this.router.navigate(['login']);
  }

  openGiftCard() {
    //this.showGiftCard = true;
    const setting = this.settingService.getCompanySetting();
    const companyId = btoa(setting.oocls_company_id);

    let userPkid = null;
    const loggedInUser = this.settingService.getUserInfo();
    if (loggedInUser) {
      userPkid = loggedInUser.userPkid;
    }

    this.webstorage.sessionSt_giftCardFromPage = window.location.href;
    this.router.navigate(['giftcard'], {
      queryParams:
      {
        c: companyId,
        from: 'qr',
        u: userPkid ? btoa(userPkid.toString()) : ''
      }
    });
  }

  closeGiftCard() {
    this.showGiftCard = false;
  }

  onUserClick() {
    const setting = this.settingService.getCompanySetting();

    if (!setting) return;

    if (setting.qrType === QRType.Table) {
      this.router.navigate(['loginnew'], { queryParams: { T: setting.tablePkid, skipResume: 1, V: generateGuid() } });

    } else if (setting.qrType === QRType.Store) {
      this.router.navigate(['loginnew'], { queryParams: { L: setting.oocls_location_pkid, C: setting.oocls_company_pkid, skipResume: 1, V: generateGuid() } });
    }

  }

  get loyaltyAmount(): number {

    const user = this.settingService.getUserInfo();
    if (user && user.userPkid > 0) {
      const amount = user.points && user.ratio ? Number((user.originPoints - this.usedPoints) / user.ratio) : 0;
      return amount;
    }
    return 0;
  }


  get usedPoints(): number {
    let point = 0;
    if (!this.userSelectedStore || !this.userSelectedStore.storeCart || !this.userSelectedStore.storeCart.orderItems) return 0;

    const userService = this.settingService.getUserSerivce();

    if (userService && userService.entireReward) {
      point = userService.entireReward.point;
    }

    const totalRewardPoints = this.userSelectedStore.storeCart.orderItems
      .filter(item => item.hasReward)
      .reduce((total, item) => total + item.reward.point, 0);

    return totalRewardPoints + point;
  }
}

